import type { CourseTypes } from '@/models/catalog/course';
import type {
  Goal,
  Language,
  ProfileStepIds,
  Scholarity,
  Seniority,
} from '@/models/recommendation';
import type { JobTitle } from '@/models/taxonomy/job';

export enum ProfileFields {
  AgreedToReceiveEmails = 'agreed_to_receive_emails',
  NonResident = 'non_resident',
  Email = 'email',
  Phone = 'phone',
  CurrentJob = 'current_job',
  DesiredJob = 'desired_job',
  AddressCity = 'address_city',
  AddressState = 'address_state',
  Scholarity = 'scholarity',
  Seniority = 'seniority',
  Goal = 'goal',
  CourseTypes = 'course_types',
  Languages = 'languages',
}

export interface QuizAnswers {
  [ProfileFields.AgreedToReceiveEmails]?: boolean | null;
  [ProfileFields.NonResident]?: boolean | null;
  [ProfileFields.Email]?: string | null;
  [ProfileFields.Phone]?: string | null;
  [ProfileFields.CurrentJob]?: JobTitle | null;
  [ProfileFields.DesiredJob]?: JobTitle | null;
  [ProfileFields.AddressCity]?: string | null;
  [ProfileFields.AddressState]?: string | null;
  [ProfileFields.Scholarity]?: Scholarity | null;
  [ProfileFields.Seniority]?: Seniority | null;
  [ProfileFields.Goal]?: Goal | null;
  [ProfileFields.CourseTypes]?: CourseTypes[] | null;
  [ProfileFields.Languages]?: Language[] | null;
}

export interface QuestionProps {
  id: ProfileStepIds;
  shouldShow?: (answers: QuizAnswers) => boolean;
}
